import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder } from '@angular/forms';
import { BaseModalDirective } from '../../base-modal';
import { SigninService } from '@app/gateway/signin/signin.service';

@Component({
  selector: 'nh-id-verification-success',
  templateUrl: './id-verification-success.component.html',
  styleUrl: './id-verification-success.component.scss',
  standalone: false
})
export class IdVerificationSuccessComponent extends BaseModalDirective implements OnInit {
  isMobileUser: boolean = false;
  constructor(
    protected modalRef: BsModalRef,
    protected builder: FormBuilder,
    protected router: Router,
    private signinService : SigninService,
  ) {
    super(modalRef, builder);
  }

  ngOnInit(): void {
    this.isMobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  }

  onContinue(): void {
    this.hide(true);
    const userName = sessionStorage.getItem('userName');
    this.signinService.getAccountData(userName).subscribe(data => {
      if (data) {
        sessionStorage.setItem('currentUser', JSON.stringify(data));
        sessionStorage.setItem('appNum', data['appNum']);
        sessionStorage.setItem('individualId', data['indvId']);
        sessionStorage.setItem('hoh', data['headOfHousehold']);
        sessionStorage.setItem('firstTimeAccessSw', data['firstTimeAccessSw']);
        this.router.navigateByUrl('user-profile/benefit-dashboard');
      }
    })
  }
}
